import React from "react";
import AppButton from "../../../../shared/components/generic/button/app-button";
import "./admin-section.css";

const AdminSection = ({
	title,
	actionLabel,
	onAction,
	actionStartIcon = "plusCircle",
	children
}) => {
	const hasAction = actionLabel && typeof onAction === "function";

	return (
		<section className="admin-section">
			{title && (
				<div className="admin-section__header">
					<h3 className="admin-section__title">
						{title}
					</h3>
				</div>
			)}

			{children}

			{hasAction && (
				<div className="admin-section__footer">
					<AppButton
						type="button"
						startIcon={actionStartIcon}
						className="admin-section__action"
						onClick={onAction}
					>
						{actionLabel}
					</AppButton>
				</div>
			)}
		</section>
	);
};

export default AdminSection;